import type { LabeledValue } from 'antd/lib/select';

import type { NameValue, SubjectTotal } from '../../../models/dashboard';
import type { LineChartData } from '../../../models/echarts';
import { BarData, CategoryData } from '../../../models/echarts';

export const datesRange: LabeledValue[] = [
  {
    label: '1 Week',
    value: '1 weeks',
  },
  {
    label: '1 Month',
    value: '1 months',
  },
  {
    label: '2 Months',
    value: '2 months',
  },
  {
    label: '3 Months',
    value: '3 months',
  },
  {
    label: '6 Months',
    value: '6 months',
  },
  {
    label: '12 Months',
    value: '12 months',
  },
  {
    label: 'All data',
    value: 'All data',
  },
];

export const getPercentageBarData = (data: SubjectTotal[] = []): [BarData, CategoryData] => {
  const totals: number[] = [];
  const labels: string[] = [];
  const total = data.reduce((acc, d) => {
    totals.push(d.total);
    labels.push(d.subject);
    return acc + d.total;
  }, 0);
  const percents = data.map((d) => Math.round((d.total / total) * 1000) / 10);
  return [new BarData(percents, totals), new CategoryData(labels)];
};

export const mapNameValueToBarChartData = (data: NameValue[] = []): [BarData, CategoryData] => {
  const totals: number[] = [];
  const labels: string[] = [];
  const total = data.reduce((acc, d) => {
    totals.push(d.value);
    labels.push(d.name);
    return acc + d.value;
  }, 0);
  const percents = data.map((d) => Math.round((d.value / total) * 1000) / 10);
  return [new BarData(percents, totals), new CategoryData(labels)];
};

export const mapNameValueToNon100PercentBarChartData = (data: NameValue[] = []): [BarData, CategoryData] => {
  const percents: number[] = data.map((d) => Math.round(d.value * 1000) / 10);
  // We map to -1 to avoid breaking the type, while marking the totals to not be used
  const totals: number[] = data.map(() => -1);
  const labels: string[] = data.map((d) => d.name);
  return [new BarData(percents, totals), new CategoryData(labels)];
};

export const dateTimeFilterFormat = 'YYYY-MM-DD HH:mm:ss';

export const getChatDailyCSV = (data: LineChartData[]) => {
  let csv = 'Date,Total chats (per day),Total searches (per day),Total unique searchers (per day)\n';
  const [{ data: chats }, { data: searches }, { data: uniqueSearches }, { data: dates }] = data;

  for (let i = 0; i < dates.length; i++) {
    const line = `${(dates[i] as string).replace(',', '')},${chats[i]},${searches[i]},${uniqueSearches[i]}\n`;
    csv += line;
  }

  return csv;
};
